import React from 'react';
import { IntCountProvider } from './src/utils/IntCountContext';
import { InvestProvider } from './src/utils/InvestContext';
import { LanguageProvider } from './src/utils/LanguageContext';

export const wrapRootElement = ({ element }) => (
  <IntCountProvider>
    <InvestProvider>
      <LanguageProvider>
        {element}
      </LanguageProvider>
    </InvestProvider>
  </IntCountProvider>
);
